module.exports = __webpack_public_path__ + "img/thumb_23.6d5939fe.png";